import { render, staticRenderFns } from "./appModal.vue?vue&type=template&id=10fde068&scoped=true"
import script from "./appModal.vue?vue&type=script&lang=js"
export * from "./appModal.vue?vue&type=script&lang=js"
import style0 from "./appModal.vue?vue&type=style&index=0&id=10fde068&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fde068",
  null
  
)

export default component.exports